import manager from 'app/module46/component-manager.js';

manager.register('event-registration', (component, elements, attributes, properties) => {

	const {
		tableOptionCheckbox,
		videoOptionCheckbox,
		photoOptionCheckbox,
		tableCount,
		videoOptionCount,
		photoOptionCount,
		imageCount,
		videoProductCount,
		photoProductCount,
		tableAmount,
		videoAmount,
		photoAmount,
		photoNote
	} = elements;

	const tablePrice = tableAmount?.dataset.price;
	const videoPrice = videoAmount?.dataset.price;
	const photoPrice = photoAmount?.dataset.price;

	const videoMultiple = videoProductCount?.dataset.multiple;
	const photoMultiple = photoProductCount?.dataset.multiple;

	const showInputSection = (input) => {
		input.closest('.form__field').style.removeProperty('display');
	};

	const hideInputSection = (input) => {
		input.closest('.form__field').style.display = 'none';
	};

	const updateTableAmount = () => {
		tableAmount.innerHTML = (tableCount.value * tablePrice).toFixed(2) + ' $';
	};

	const updateVideoAmount = () => {
		videoAmount.innerHTML = (videoOptionCount.value * videoPrice).toFixed(2) + ' $';
		videoProductCount.innerHTML = videoOptionCount.value * videoMultiple;
	};

	const updatePhotoAmount = () => {
		photoAmount.innerHTML = (photoOptionCount.value * photoPrice).toFixed(2) + ' $';
		photoProductCount.innerHTML = photoOptionCount.value * photoMultiple;
	};

	const handleTableCheckboxChange = () => {
		if (tableOptionCheckbox.checked) {
			showInputSection(tableCount);
			showInputSection(imageCount);
			showInputSection(tableAmount);
		} else {
			hideInputSection(tableCount);
			hideInputSection(imageCount);
			hideInputSection(tableAmount);
		}
	};

	const handleVideoCheckboxChange = () => {
		if (videoOptionCheckbox.checked) {
			showInputSection(videoOptionCount);
			showInputSection(videoProductCount);
			showInputSection(videoAmount);
		} else {
			hideInputSection(videoOptionCount);
			hideInputSection(videoProductCount);
			hideInputSection(videoAmount);
		}
	};

	const handlePhotoCheckboxChange = () => {
		if (photoOptionCheckbox.checked) {
			showInputSection(photoOptionCount);
			showInputSection(photoProductCount);
			showInputSection(photoAmount);
			showInputSection(photoNote);
		} else {
			hideInputSection(photoOptionCount);
			hideInputSection(photoProductCount);
			hideInputSection(photoAmount);
			hideInputSection(photoNote);
		}
	};


	if (tableOptionCheckbox) {
		tableCount.addEventListener('keyup', updateTableAmount);
		tableCount.addEventListener('change', updateTableAmount);

		tableOptionCheckbox.addEventListener('change', handleTableCheckboxChange);

		updateTableAmount();
		handleTableCheckboxChange();
	}

	if (videoOptionCheckbox) {
		videoOptionCount.addEventListener('keyup', updateVideoAmount);
		videoOptionCount.addEventListener('change', updateVideoAmount);

		videoOptionCheckbox.addEventListener('change', handleVideoCheckboxChange);

		updateVideoAmount();
		handleVideoCheckboxChange();
	}

	if (photoOptionCheckbox) {
		photoOptionCount.addEventListener('keyup', updatePhotoAmount);
		photoOptionCount.addEventListener('change', updatePhotoAmount);

		photoOptionCheckbox.addEventListener('change', handlePhotoCheckboxChange);

		updatePhotoAmount();
		handlePhotoCheckboxChange();
	}
});
